import React, { useState } from "react";
import "./Header.css";
import { withStyles, Tabs, Tab } from "@material-ui/core";
import { SearchBar } from "../../../../componentsEmp";
import { Add } from "@material-ui/icons";
import { Tooltip, IconButton } from "../../../../components";
import { useSelector } from "react-redux";
import Swal from 'sweetalert2';

const AntTabs = withStyles({
  root: {
    marginTop: "8px",
  },
  indicator: {
    backgroundColor: "#197EE6",
    height: "5px",
  },
})(Tabs);
const AntTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: "16px",
    marginRight: theme.spacing(2),
    fontFamily: ["Roboto"].join(","),
    "&:hover": {
      color: "#40a9ff",
      opacity: 1,
    },
    "&$selected": {
      color: "#1890ff",
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: "#40a9ff",
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const Header = ({
  setOpenModal,
  index,
  setIndex,
  _switch,
  setSwitch,
  query,
  setSkip,
  setQuery,
  disabledNewAviso,
  tipoPlan,
  totalavisos,
  avisosInfo
}) => {
  const [search, setSearch] = useState("");
  const handleChange = (event, newValue) => {
    setQuery({});
    setSearch("");
    setSkip(0);
    setIndex(newValue);
    delete query.search;
  };
  const handleClick = () => {
    query.search = search;
    setSkip(0);
    setQuery(query);
    setSwitch(!_switch);
  };
  const _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleClick();
    }
  };

  const usuario = useSelector((state) => state.authEmp.usuario);
  const validateAvisos = (qty) => {

    /*if (disabledNewAviso) 
      return false;
    else 
      setOpenModal(true);*/
      let plan = '';
      if (usuario){
        plan = usuario.plan.nombrePlan;
      }
    if(disabledNewAviso ){
      if (qty == 0){
        Swal.fire('Atención!', "Ha consumido el máximo de publicaciones de su Plan: "+plan+", si requiere subir más anuncios, contáctese con nuestros ejecutivos" +
        " llamando al +56 9 7667 2851 o al correo contacto@zaptalent.cl", 'warning');
        
        /*alert("Ha consumido el máximo de publicaciones de su Plan: "+plan+", si requiere subir más anuncios, contáctese con nuestros ejecutivos" +
        " llamando al +56 9 7667 2851 o al correo contacto@zaptalent.cl");*/
      }
    }else{
      if (qty == 1)
      {
        Swal.fire('Atención!',"Solo le queda un aviso por publicar de su Plan: "+plan+", si requiere subir más anuncios, contáctese con nuestros ejecutivos" +
        " llamando al +56 9 7667 2851 o al correo contacto@zaptalent.cl", 'warning')
        .then(function(){setOpenModal(true)});
      }else{
        setOpenModal(true);
      }
    }
    
  };
  return (
    <div className="header-avisos-emp" style={{ width: "inherit" }}>
      <div className="left-header-avisos-emp">
        <p>Mis Avisos</p>
      </div>
      <div className="right-header-avisos-emp">
        <div className="search-ofertas">
          <SearchBar
            onChange={setSearch}
            onClick={handleClick}
            value={search}
            onKeyDown={_handleKeyDown}
          />
        </div>
        <AntTabs value={index} onChange={handleChange} aria-label="ant example">
          <AntTab label="Todos" />
          <AntTab label="Activos" />
          <AntTab label="Caducados" />
        </AntTabs>
        <Tooltip 
          title={`Nuevo Aviso. Restantes: ${
            avisosInfo && avisosInfo.configPlan.limitePublicaciones === 0
              ? "Ilimitado"
              : avisosInfo && ( avisosInfo.configPlan.limitePublicaciones - avisosInfo.publicacionesRealizadas)
          }`}
        >
          <IconButton
            bg="primary"
            onClick={() => (disabledNewAviso ? validateAvisos(0) : ( validateAvisos(avisosInfo.configPlan.limitePublicaciones - avisosInfo.publicacionesRealizadas))) }
          >
            <Add />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
};

export default Header;
